<template>
  <v-tooltip v-if="selectedCounter" top>
    <template #activator="{ on }">
      <v-chip
        data-test="select-all-toggle"
        small
        :color="chipColor"
        v-on="on"
        @click.stop="() => $emit('toggle')"
        >{{ selectedCounter }}
      </v-chip>
    </template>
    Click to reset all
  </v-tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  itemsCount?: number
  selectedCount?: number
}>()

const selectedCounter = computed(() => {
  if (props.itemsCount && props.selectedCount) {
    return `${props.selectedCount} / ${props.itemsCount}`
  }

  if (!props.itemsCount && props.selectedCount) {
    return props.selectedCount
  }
})

const chipColor = computed(() => {
  if (props.itemsCount === props.selectedCount) {
    return 'var(--color-silver)'
  } else {
    return 'var(--color-blue--lighter)'
  }
})
</script>

<style scoped></style>
